<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        2019年大连海大智龙科技有限公司获得知识产权管理体系认证证书和质量管理体系认证证书
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
      <div class="div-text-left news-Regular-14b6">
        <span>2020-04-07</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
      </div>
      <div class="div-line  divcss5">

      </div>
      <div class="div-row div-bottom30">
        <p class="indentation">
          2019年大连海大智龙科技有限公司获得知识产权管理体系认证证书和质量管理体系认证证书。
        </p>
      </div>
      <table>
        <tr>
          <td>
            <img src="static/imgts/news10/1.png" />
          </td>
          <td>
            <img src="static/imgts/news10/2.png" />
          </td>
        </tr>
        <tr>
          <td>
            知识产权管理体系认证证书
          </td>
          <td>
            质量管理体系认证证书
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isflag1: true,
        isflag2: false,
        isflag3: false
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (parseInt(scrollTop) >= 550 && parseInt(scrollTop) < 1200) {
          // alert(scrollTop)
          this.isflag2 = true;
        }
        if (parseInt(scrollTop) >= 1200) {
          this.isflag3 = true;
        }

      },
      destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
      },
    },
  };

</script>

<style scoped>
  img {
    margin-top: 30px;
  }

  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

  .div-padding-left {
    padding-left: 36px;
  }

  .div-top30 {
    margin-top: 30px;
  }

  .div-top0 {
    margin-bottom: 0px !important;
  }

  img {
    vertical-align: middle;
    border-style: none;
    width: 100%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news10.vue